'use strict';

import ngResource from 'angular-resource';

function DailyGroupActivePowerService($resource) {
    return $resource(
        '/api/daily_group_active_power/:id', { id: '@id' },
        {
            show: { method: 'GET', isArray: false }
        }
    )
}

export default angular.module('leptonApp.DailyGroupActivePowerService', ['ngResource'])
    .factory('DailyGroupActivePowerService', ['$resource', DailyGroupActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/daily_group_active_power/daily_group_active_power.service.js